import { apiSlice } from "../../app/api/apiSlice"
import { blobExcelOption } from "../../app/services/base"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const resultLogApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getResultLog: builder.query<any, any>({
            query: (args) => "/ResultLog/GetResult".concat(generateFormatedURL(args)),
        }),

        getResultExcel: builder.mutation({
            query: (body) => ({
                ...blobExcelOption,
                url: '/ResultLog/GetExcel',
                method: 'POST',
                body:  body,
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'blob' 
                
            })
        }),
    })
})

export const {
    useLazyGetResultLogQuery,
    useGetResultExcelMutation
} = resultLogApiSlice  